import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const workflowsPlugin = createPlugin({
  id: 'workflows',
  routes: {
    root: rootRouteRef,
  },
});

export const WorkflowsPage = workflowsPlugin.provide(
  createRoutableExtension({
    name: 'WorkflowsPage',
    component: () => import('./components/index').then(m => m.IndexPage),
    mountPoint: rootRouteRef,
  }),
);
